import { format } from 'date-fns'
import { PayTypeEnum } from 'types/enum'
import { isLogined } from 'service/sign'
import { RouterPaths, PARAM_KEYS } from './constant'
import ModelFn from 'components/model/ModelFn'
import { getshoplink } from "service/shop"

interface Validate {
  value: any
  hint: string
}
export function isUnverified() {
  const captchaType = window['captcha_type']

  if (captchaType && !window['captcha']) {
    return true
  }
  return false
}

export function getCaptcha() {
  const captchaType = window['captcha_type']

  if (captchaType) {
    return window['captcha']
  }

  return null
}
export function resetVerify(setreset){
  const captchaType = window['captcha_type']
  if (captchaType && window['captcha']) {
    setreset(true)
    setTimeout(() => {
      setreset(false)
    }, 10)
    window['captcha'] = ''
  }
}

export function isWidthMobile(): boolean {
  return window.matchMedia('(max-width: 767px)').matches
}

export function formsValidate(fn, args: Validate[]) {
  for (const v of args) {
    if (!fn(v.value)) {
      return [false, v.hint]
    }
  }
  return [true, null]
}

export function notEmptyValidate(args: Validate[]) {
  const fn = (value) => {
    return value != null && value !== ''
  }
  return formsValidate(fn, args)
}

export function isMobileChorme() {
  const ua = window.navigator.userAgent.toLowerCase()
  if (ua.includes('android') && ua.includes('chrome')) {
    return true
  }
  return false
}

export function isIOS(): boolean {
  const ua = navigator.userAgent.toLowerCase()
  if (/iphone|ipod/i.test(ua)) return true
  if (navigator.platform === 'iPad') return true
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true
  return false
}

export function isAndroid(): boolean {
  const ua = navigator.userAgent.toLowerCase()
  return /android/i.test(ua)
}

export function isMobile(): boolean {
  // 1. 触摸能力（核心）
  const isTouchDevice = navigator.maxTouchPoints > 0
  const isSmallScreen = window.innerWidth <= 768

  // 2. UA 兜底（覆盖绝大多数常规手机/平板）
  const ua = navigator.userAgent.toLowerCase()
  const mobileKeywords = ['android', 'iphone', 'ipad', 'windows phone', 'harmonyos']
  const hasMobileUA = mobileKeywords.some(keyword => ua.includes(keyword))

  // 3. 专门识别 iPad（覆盖新旧系统）
  const isIPad =
    navigator.platform === 'iPad' ||                     // 旧版 iOS（<=12）
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) // iPadOS 13+ 伪装模式

  return (isTouchDevice && isSmallScreen) || hasMobileUA || isIPad
}
export function isWechat(): boolean {
  return /micromessenger/i.test(navigator.userAgent)
}

export function toNumber(value: any, defaultNumber?: number): number {
  defaultNumber = defaultNumber || 0
  const num = Number(value)
  if (value == null) {
    return defaultNumber
  }
  if (isNaN(num)) {
    return defaultNumber
  }
  return num
}

export function openUrl(url: string, blank = true) {
  window.open(url, blank ? '_blank' : undefined)
}

export function getAllUrlParams(): Record<string, string> {
  const params: Record<string, string> = {}
  new URLSearchParams(window.location.search).forEach((value, key) => {
    params[key] = value
  })
  return params
}
export function getSearch(key: string): string | undefined {
  const search = window.location.search.slice(1)
  if (search) {
    const searchObj = {}
    search.split("&").forEach(s => {
      const eqIdx = s.indexOf("=")
      if (eqIdx !== -1) {
        const k = s.slice(0, eqIdx)
        const v = s.slice(eqIdx + 1)
        searchObj[k] = decodeURIComponent(v)
      }
    })

    return searchObj[key]
  }
}

export function timeRemain (time: number) {
  const ms = time * 1000 - Date.now()
  if (ms <= 0) return '0天'
  const day = Math.floor(ms / 1000 / 60 / 60 / 24)
  if (day >= 1) return `${day}天`
  const h = Math.floor(ms / 1000 / 60 / 60)
  const m = Math.floor(ms / 1000 / 60) % 60
  return `${h}小时${m}分钟`
}

export function getNowString() {
  const now = new Date()
  const y = now.getFullYear()
  const M = now.getMonth() + 1
  const d = now.getDate()
  const h = now.getHours()

  return `${y}${M}${d}${h}`
}

export function showMoney(n: any) {
  const r = (n / 100).toFixed(2)
  return `¥${r}`
}

export function defaultDateFormat(t: any, tep?:  string) {
  tep = tep || 'yyyy.MM.dd HH:mm:ss'
  return format(t * 1000, tep)
}

export function payTypeToCurrencySymbol(t: string) {
  switch (t) {
  case PayTypeEnum.paypal:
    return "$"
  case PayTypeEnum.alipay_qr_intl:
    return "HK$"
  default:
    return "¥"
  }
}
//去除首尾空格
export function trim(string) {
  if(string.trim) {
    return string.trim()
  }else {
    const reg = /^\s+|\s+$/g
    return string.replace(reg,"")
  }
}


export const isLitePage = () => window.location.pathname.startsWith('/payment_lite')

export const toLitePath = (path: string): string => {
  if (isLitePage() && !path.includes('/payment_lite')) {
    return path.replace('/payment', '/payment_lite')
  }
  return path
}

export const getLoginPath = () => {
  return isMobile() ? toLitePath(RouterPaths["signin-phone"]) : toLitePath(RouterPaths["signin-qr"])
}

export const toShop = async (type) => {
  if(!isLogined()){
    const url = `${getLoginPath()}?redirect=${toLitePath(RouterPaths.shop)}&type=${type}`
    ModelFn.confirm({
      text: "请先登录穿梭账号",
      onConfirm: () => { window.location.replace(url) },
      noCancel: true
    })
  }else { 
    const res = await getshoplink()
    if(res.code === 0) {
      window.location.replace(res.links[type])
    }
  }

  

}

export const storeParams = () => {
  const params = PARAM_KEYS.reduce((acc, key) => {
    const value = getSearch(key)
    if (value) {
      acc[key] = value
    }
    return acc
  }, {})
  if(params && Object.keys(params).length > 0){
    sessionStorage.setItem('sourceParams', JSON.stringify(params))
  }
}
export const getStoredParams = () => {
  try {
    const params = sessionStorage.getItem('sourceParams')
    return params ? JSON.parse(params) : null
  } catch (error) {
    return null
  }
}

const LOADED_SCRIPTS: Record<string, Promise<void>> = {}

export const SCRIPT_URLS = {
  riddler: `${process.env.PUBLIC_URL}/js/riddler-sdk-0.2.2.js`,
  aliyunCaptcha: 'https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js',
  yidun: `${process.env.PUBLIC_URL}/js/yidun-captcha.js`,
  luckyCanvas: `${process.env.PUBLIC_URL}/js/lucky-canvas@1.7.25.js`,
  gtag: (id: string) => `https://www.googletagmanager.com/gtag/js?id=${id}`,
}

export function loadScript(src?: string): Promise<void> {
  if (!src) return Promise.resolve()
  if (LOADED_SCRIPTS[src]) return LOADED_SCRIPTS[src]
  const promise = new Promise<void>((resolve) => {
    const existing = document.querySelector(`script[src="${src}"]`) as HTMLScriptElement | null
    if (existing) {
      if (existing.dataset.loaded === 'true') return resolve()
      existing.addEventListener('load', () => resolve())
      existing.addEventListener('error', () => resolve())
      return
    }
    const script = document.createElement('script')
    script.src = src
    script.async = true
    script.onload = () => {
      script.dataset.loaded = 'true'
      resolve()
    }
    script.onerror = () => {
      script.remove()
      delete LOADED_SCRIPTS[src]
      resolve()
    }
    document.head.appendChild(script)
  })
  LOADED_SCRIPTS[src] = promise
  return promise
}

const PUBLIC_PAGES = ['/payment/invite', '/payment/lottery']

export function isPublicPage(): boolean {
  return PUBLIC_PAGES.some(page => window.location.pathname.startsWith(page))
}
